
import { createHeroCarousel } from "./pastore-hero-carousel.js";
class PastoreBeerHero extends HTMLElement {
 connectedCallback() {
  if (this.initialised) return;
  this.initialised = true;this.abort = new AbortController();
  queueMicrotask(() => this.initialise());
 }
 initialise() {
  if (!this.isConnected) return;
  const hero=this,config=JSON.parse(this.querySelector(".pastore-hero-config").textContent);
  if (!config.beers.length) return;
  const viewer=hero.querySelector("model-viewer"),stage=hero.querySelector(".can-stage"),motionPreference=(window.PastoreMotion || matchMedia("(prefers-reduced-motion: reduce)"));
  const listen=(target,name,action,options={})=>target.addEventListener(name,action,{...options,signal:this.abort.signal});
  let isInView=true,frame=0,pointerX=0,pointerY=0,prepared=false;
  function updateTilt() {
   frame=0;if (!viewer.loaded||!hero.isConnected||motionPreference.userPaused)return;
   const range=Math.max(1,Math.min(1100,hero.offsetHeight));
   const scroll=Math.min(1,Math.max(0,(scrollY-(hero.getBoundingClientRect().top+scrollY))/range));
   const eased=scroll*scroll*(3-2*scroll);
   const polar=motionPreference.matches?78:78+(config.scrollMotion?eased*12:0)+pointerY*3;
   const azimuth=motionPreference.matches?0:pointerX*6;
   viewer.cameraOrbit=azimuth.toFixed(3)+"deg "+polar.toFixed(3)+"deg 105%";
  }
  function requestTilt(){if(!frame&&isInView&&!document.hidden&&!motionPreference.matches)frame=requestAnimationFrame(updateTilt);}
  const resetPointer=()=>{pointerX=0;pointerY=0;requestTilt();};
  listen(hero,"pointermove",event=>{
   if(event.pointerType!=="mouse"||motionPreference.matches||!config.mouseMotion)return;
   const rect=hero.getBoundingClientRect();
   pointerX=Math.max(-1,Math.min(1,(event.clientX-rect.left)/rect.width*2-1));
   pointerY=Math.max(-1,Math.min(1,(event.clientY-rect.top)/Math.min(innerHeight,rect.height)*2-1));requestTilt();
  },{passive:true});
  listen(hero,"pointerleave",resetPointer);listen(window,"blur",resetPointer);
  function syncMotion(){
   viewer.toggleAttribute("auto-rotate",Boolean(viewer.loaded)&&config.rotateCan&&!motionPreference.matches&&!document.hidden&&isInView&&hero.isConnected);
   if(motionPreference.matches){cancelAnimationFrame(frame);frame=0;pointerX=0;pointerY=0;updateTilt();viewer.jumpCameraToGoal?.();}else requestTilt();
  }
  function showCanFallback(){
   stage.classList.remove("is-loaded");stage.classList.add("has-error");viewer.setAttribute("aria-hidden","true");
   stage.querySelector(".can-fallback").removeAttribute("aria-hidden");
  }
  const carousel=createHeroCarousel({viewer,stage,hero,motionPreference,showCanFallback});this.carousel=carousel;
  async function loaded(){
   if(prepared)return;prepared=true;
   try{
    await carousel.prepare();if(!hero.isConnected)return;
    updateTilt();viewer.jumpCameraToGoal?.();syncMotion();
    requestAnimationFrame(()=>requestAnimationFrame(()=>{
     if(!hero.isConnected)return;
     stage.classList.remove("has-error");stage.classList.add("is-loaded");viewer.removeAttribute("aria-hidden");
     stage.querySelector(".can-fallback").setAttribute("aria-hidden","true");
    }));
   }catch(error){console.warn("Pastore hero: could not show the 3D can.",error);showCanFallback();}
  }
  listen(viewer,"load",loaded);listen(viewer,"error",showCanFallback);
  listen(motionPreference,"change",syncMotion);listen(document,"visibilitychange",syncMotion);
  listen(window,"scroll",requestTilt,{passive:true});listen(window,"resize",requestTilt);
  this.observer=new IntersectionObserver(([entry])=>{isInView=entry.isIntersecting;syncMotion();});
  this.observer.observe(stage);this.cancelFrame=()=>cancelAnimationFrame(frame);
  listen(document,"shopify:block:select",event=>{
   if(event.detail.sectionId===hero.dataset.sectionId)carousel.select(event.detail.blockId);
  });
  const menu=hero.querySelector(".mobile-menu"),menuPanel=hero.querySelector(".mobile-navigation");
  listen(menu,"click",()=>{const expanded=menu.getAttribute("aria-expanded")==="true";menu.setAttribute("aria-expanded",String(!expanded));menuPanel.hidden=expanded;});
  listen(hero,"keydown",event=>{if(event.key==="Escape"){menuPanel.hidden=true;menu.setAttribute("aria-expanded","false");}});
  if(customElements.get("model-viewer")){if(viewer.loaded)loaded();syncMotion();}
  else import(new URL(this.dataset.viewerModule,location.href).href).then(()=>{
   customElements.get("model-viewer").minimumRenderScale=1;if(viewer.loaded)loaded();syncMotion();
  }).catch(showCanFallback);
 }
 disconnectedCallback(){this.abort?.abort();this.carousel?.destroy();this.observer?.disconnect();this.cancelFrame?.();this.initialised=false;}
}
if(!customElements.get("pastore-beer-hero"))customElements.define("pastore-beer-hero",PastoreBeerHero);
